import React, { FC, ReactNode } from 'react'

export const ResponseIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container'>
      <img
        srcSet={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/cbc76a1cda8d071093780dad66f1ac79_Bitmap.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/7d373498ea2a8627bc75139a380e2cdd_Bitmap@2x.png, ' +
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/0ef4b1fdf6ad3aee15385fd7ce72844d_Bitmap@3x.png'
        }
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/cbc76a1cda8d071093780dad66f1ac79_Bitmap.png'
        }
        width={74}
        height={100}
        alt={''}
      />
    </div>
  )
}
